// Teams and email notifications can't call back into Runway, so their action buttons deep-link into the web app
// with `?<selectedParam>=<id>&<actionParam>=<action>`. The action param is consumed (removed from the URL) by
// the component that owns the target, so a reload doesn't prompt again; the selected param stays so the target
// remains selected.
export const consumeNotificationActionFromURL = (
    selectedParam: string,
    actionParam: string,
    ownsTarget: (targetId: string) => boolean,
): { targetId: string; action: string } | null => {
    const url = new URL(window.location.toString());
    const targetId = url.searchParams.get(selectedParam);
    const action = url.searchParams.get(actionParam);
    if (!targetId || !action || !ownsTarget(targetId)) {
        return null;
    }
    url.searchParams.delete(actionParam);
    window.history.replaceState({}, '', url);
    return { targetId, action };
};
